
import React from 'react';
import styled from 'styled-components';
import { Colors } from '.';
import { Images } from '../@resources/img';
import { Flexer } from '../app/dashboard/elements/LayoutElements';

// master, visa, american_express, discover, jcb, maestro, diners_club, unionpay

const PaymentCardText = styled.div`
    padding: 0 1rem;
    color: ${Colors.text};
    font-weight: 450;
    text-align: right;
    border-radius: 1000rem;
`;

const positions = {
    'amex': '0% 0%',
    'american_express': '0% 0%',
    'diners_club': '100% 0%',
    'discover': '0% 33.33%',
    'jcb': '100% 33.33%',
    'maestro': '0% 66.66%',
    'master': '100% 66.66%',
    'mastercard': '100% 66.66%',
    'unionpay': '0% 100%',
    'visa': '100% 100%',
};

export type PaymentCardType = keyof typeof positions;

export const PaymentCardLogo = styled.div<{ type: PaymentCardType }>`
    display: inline-block;
    width: 5rem;
    height: 3.28rem;
    background: url(${Images.PaymentCards}) no-repeat;
    background-position: ${p => positions[p.type] || ''};
    background-size: 200% 400%;
    overflow: hidden;
    text-indent: -9999px;
    text-align: left;
`;

export const PaymentCard = React.memo<{ type: PaymentCardType, digits: string, expiry: string }>(({ type, digits, expiry }) => {
    return <Flexer flex="row">
        <PaymentCardLogo type={type} />
        <Flexer flex="row" center="align">
            <PaymentCardText>**** **** **** {digits} <br /> expires {expiry}</PaymentCardText>
        </Flexer>
    </Flexer>;
});
